const REPEATED_DIGITS = /^(\d)\1{10}$/

export const onlyDigits = (value: string) => value.replace(/\D/g, '')

const maskableCpf = /^[\d.-]+$/

export const toDocumentValue = (value: string) => {
  if (value !== value.trim() || !maskableCpf.test(value)) {
    return value
  }

  return formatCpf(value)
}

export const formatCpf = (value: string) => {
  const digits = onlyDigits(value).slice(0, 11)

  return digits
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2')
}

export const isValidCpf = (value: string) => {
  const cpf = onlyDigits(value)

  if (cpf.length !== 11 || REPEATED_DIGITS.test(cpf)) {
    return false
  }

  const checkDigit = (length: number) => {
    const sum = cpf
      .slice(0, length)
      .split('')
      .reduce((total, digit, index) => total + Number(digit) * (length + 1 - index), 0)
    const rest = (sum * 10) % 11

    return rest === 10 ? 0 : rest
  }

  return checkDigit(9) === Number(cpf[9]) && checkDigit(10) === Number(cpf[10])
}
